<template>
<div class="example">
  <apexcharts  type="line" :options="chartOptions" :series="series"></apexcharts>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
//import VueApexCharts from '../../../dist/vue-apexcharts'
export default {
  name: 'LineExample',
  components: {
    apexcharts: VueApexCharts,
  },
  props: ['seriesp', 'labelsp'],
  data: function() {
    return {

      chartOptions: {},
      labels: ["1"],
      series: [{
        name: 'blank',
        data: [0]
      }]
    }
  },
  methods: {
    generateDayWiseTimeSeries(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = baseval;
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
        series.push([x, y]);
        baseval += 86400000;
        i++;
      }
      return series;
    },
    updateChart() {
      console.log(this.series);
    }
  },
  watch: {
    seriesp(val){
      console.log("SERIES CHANGED " + val)

      this.chartOptions = {
        // xaxis: {
        //   type: 'categories',
        //   categories: val.labels,
        //   axisBorder: {
        //     show: false
        //   },
        //   axisTicks: {
        //     show: false
        //   },
        //   labels: {
        //     show: false
        //   }
        //
        // },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [1, 2, 1],
          curve: 'straight'
        },
        chart: {
          type: 'line',
          zoom: {
            enabled: true
          },
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            },
            autoSelected: 'zoom'
          }
        }
      }
      console.log(this.chartOptions)
      this.series = val.series

    },
    labelsp(val){
      console.log("LABELS CHANGED " + val)
      this.labels = val;
      this.chartOptions.xaxis.categories = this.labels;
      var copy = this.chartOptions;
      this.chartOptions = [];
      this.chartOptions = copy;



    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/graphs/UserActivityApex.vue